import { combineReducers } from '@reduxjs/toolkit';

import itchReducer from './../reducers/itch';

export default combineReducers({
  itch: itchReducer
});